import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { useAtomicSetter } from '@/composables/useAtomicSetter.js';

export const useReservationDrawerStore = defineStore('reservations', () => {
  const reservationId = ref(null);

  const isOpen = computed(() => !!reservationId.value);

  const stateRefs = {
    reservationId,
  };

  const { setAtomic } = useAtomicSetter(stateRefs);

  const closeDrawer = () => {
    setAtomic('reservationId', null);
  };

  return {
    ...stateRefs,
    isOpen,
    setAtomic,
    closeDrawer,
  };
});
